/**
 * @module src/config/systemConfig
 * @author lwc
 * @description 公共方法分装.
 * @date 2020年12月1日
 * */

const systemConfig = {

    // 常量配置
    constConfig: {

    },
    // 表格配置
    tableConfig: {
      columnSorting: true,
      editor: false, // 禁用所有单元格编辑
      rowHeaders: true,
      showSelection: true,
      dragCheck: true,
      rowHeights: 26, // 行高
      manualColumnResize: true,
      manualColumnMove: false, // 禁止拖动
      autoWrapRow: true, // 允许换行
      licenseKey: 'non-commercial-and-evaluation',
      filters: true,
      dropdownMenu: ['filter_by_value', 'filter_action_bar']
    }
}

export default systemConfig
